var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"padded-space",attrs:{"id":"position-limits-view"}},[_c('div',{staticClass:"inner"},[_c('h2',[_vm._v("Open Position Limits")]),_c('BoxGrid',[_c('BoxGridBlock',{attrs:{"loadingOverlayProps":{ showRetry: true },"useLoadingOverlay":""}},[_c(_setup.PositionLimits)],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }